import { useLazyQuery } from '@apollo/client/react';
import { IS_USAGE_LIMIT_EXCEEDED } from '../queries/CheckUsageLimit';
import { loggerService } from '@brainpool/logger';
import { LoggerContextProps } from '../types/LogContext';
import { handleError } from './errorHandler';

interface UsageLimitResult {
  allowed: boolean;
  reason?: string | null;
  casesLeft?: number;
  pipelineRunsLeft?: number;
  dueDiligenceLeft?: number;
  nextRenewalDate?: number;
}

export function useCheckUsageLimit() {
  const context: LoggerContextProps = {
    action: 'isUsageLimitExceeded',
    caseId: '',
  };

  const [usageLimitQuery, { data, loading, error }] = useLazyQuery<{
    isUsageLimitExceeded: UsageLimitResult;
  }>(IS_USAGE_LIMIT_EXCEEDED, {
    fetchPolicy: 'network-only',
  });

  const checkUsageLimit = async (filter: Record<string, unknown>) => {
    try {
      const { data } = await usageLimitQuery({
        variables: { filter },
      });
      if (data?.isUsageLimitExceeded?.allowed === false) {
        loggerService.log({
          message: 'Usage limit exceeded',
          logLevel: 'error',
          context,
          userMessage: {
            message: data?.isUsageLimitExceeded?.reason || 'Usage limit exceeded.',
          },
          duration: 10000,
        });
      }
    } catch (error) {
      handleError(error, context, 'Failed to check usage limit.');
    }
  };

  return {
    checkUsageLimit,
    data,
    loading,
    error,
    result: data?.isUsageLimitExceeded,
  };
}
